export const QuestionKind = {
  NAME: "RNM",
  GENDER: "GE",
  AGE: "AG",
  LANGUAGE: "LN",
  DESCRIPTION: "DSC",
  ASSIGNEE: "ASN",
  MCQS: "MQ",
};
